<template>
  <div v-if="item.type == 'seeds'" class="pack-container mt-3">
    <div class="pack-container__row">
      <div v-for="pack in this.packs" v-bind:key="pack.id" class="pack-container__item" @click="selectItem(pack)">
        <div v-if="item.type == 'seeds'" class="flex justify-between w-full cursor-pointer items-center">
          <label :id="pack.id" class="flex">
            <input type="radio" class="checkbox" :value="pack.id" v-model="picked"
              :class="{ selected: checkitemSelected(pack) }" />
            <p class="text-sm ml-4 cursor-pointer">
              Pack {{ pack.quantity }} {{ trans.get("wizard.seeds") }} <span class="font-bold">{{ packDiscount(pack) }}</span>
            </p>
          </label>
          <div class="grid py-2 justify-items-end">
            <span class="font-bold">{{ packPrice(pack) | currency }}
              <span v-if="hasDiscount(pack)" class="line-through text-inactive-grey text-sm">{{ pack.pivot.price | currency }}</span>
            </span>
            <span class="text-sm">{{ priceBySeed(pack) | currency }}/{{ trans.get("wizard.seed") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="item.type == 'merch'" class="pack-container">
    <h5>{{ trans.choosePack[lang] }}</h5>
    <div class="pack-container__row">
      <div v-for="pack in this.packs" v-bind:key="pack.id" class="pack-container__item"
        :class="{ selected: checkitemSelected(pack) }" @click="selectItem(pack)">
        <span class="font-bold">Pack {{ pack.quantity }} {{ trans.get("wizard.seeds") }} <span class="font-bold">{{ packDiscount(pack) }}</span></span>
        <div class="grid py-2 justify-items-end">
          <span class="font-bold">{{ packPrice(pack) | currency }}
            <span v-if="hasDiscount(pack)" class="line-through text-inactive-grey text-sm">{{ pack.pivot.price | currency }}</span>
          </span>
              <span class="text-sm">{{ priceBySeed(pack) | currency }}/{{ trans.get("wizard.seed") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../mixin";
import { orderArrayPacks } from "../../utils";

export default {
  mixins: [mixin],
  props: ["packs", "item"],
  data: function () {
    return {
      itemSelected: {},
      picked: "",
    };
  },
  methods: {
    selectItem(pack) {
      if (pack) {
        this.itemSelected = pack;
        this.$emit("item-selected", pack);
      }
    },
    checkitemSelected(item) {
      return this.itemSelected.id == item.id;
    },
    packPrice(pack) {
      return pack.pivot.final_price;
    },
    packDiscount(pack) {
      return (pack.pivot.has_active_discount) ? '(-' + parseFloat(pack.pivot.discount) + '%)' : null;
    },
    priceBySeed(pack){
      return (this.packPrice(pack) / pack.quantity);
    },
    hasDiscount(pack) {
      return this.item.has_active_discount || pack.pivot.has_active_discount;
    }
  },
  created() {
    this.selectItem(this.packs && orderArrayPacks(this.packs)[0]);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables";

.pack-container {
  &.merch-container {
    padding: 16px 0 24px 0;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #90abaa;
  }

  &__row {
    margin-top: 1rem;

    @media (max-width: 500px) {
      flex-wrap: wrap;
    }
  }

  &__item {
    min-width: 120px;
    width: 100%;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border-bottom: 1px solid #adadad;

    &:last-child {
      margin-right: 0;
    }

    &:first-child {
      border-top: 1px solid #adadad;
    }

    @media (max-width: 500px) {
      max-width: 100%;
    }
  }

  .checkbox {
    width: 16px;
    height: 16px;
    appearance: none;
    /* For iOS < 15 to remove gradient background */
    background-color: transparent;
    /* Not removed via appearance */
    color: currentColor;
    border: 1px solid #adadad;
    border-radius: 50%;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
    margin-top: 0.2rem;
    cursor: pointer;

    &::before {
      content: "";
      width: 0.65em;
      height: 0.65em;
      border-radius: 50%;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em var(--form-control-color);
    }

    &.selected {
      border: max(1px, 0.15em) solid currentColor;
      outline-offset: max(1px, 0.15em);
      background-color: #f0f0f0;
      width: 16px;
      height: 16px;

      &::before {
        transform: scale(1);
      }
    }
  }
}
</style>
